
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"-41 164.9 512 512"}},[_c('path',{attrs:{"d":"M64.2 189.8c-3.1-8.9-15.7-8.9-18.9 0l-56.5 174.8h132c-.1 0-56.6-174.8-56.6-174.8zM-40.1 452.6c-2.6 8 .3 16.9 7.1 22l247.9 184-226.2-294-28.8 88zm160.8-88l94.3 294 94.3-294H120.7zm349.4 88l-28.8-88-226.3 294 247.9-184c6.9-5.1 9.7-14 7.2-22zm-85.4-262.8c-3.1-8.9-15.7-8.9-18.9 0l-56.6 174.8h132l-56.5-174.8z"}})])
      }
    
      }
    